/**
 * @deprecated Это легаси цвета, не используй их!
 */
export const LegacyColors = {
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  black: '#000',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  white: '#fff',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack80: 'rgba(0, 0, 0, 0.8)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack70: 'rgba(0, 0, 0, 0.7)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack60: 'rgba(0, 0, 0, 0.6)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack50: 'rgba(0, 0, 0, 0.5)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack40: 'rgba(0, 0, 0, 0.4)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack30: 'rgba(0, 0, 0, 0.3)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack25: 'rgba(0, 0, 0, 0.25)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack20: 'rgba(0, 0, 0, 0.2)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack15: 'rgba(0, 0, 0, 0.15)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack10: 'rgba(0, 0, 0, 0.1)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack7: 'rgba(0, 0, 0, 0.07)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack5: 'rgba(0, 0, 0, 0.05)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlack3: 'rgba(0, 0, 0, 0.03)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite10: 'rgba(255, 255, 255, 0.1)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite15: 'rgba(255, 255, 255, 0.15)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite30: 'rgba(255, 255, 255, 0.3)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite50: 'rgba(255, 255, 255, 0.5)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite80: 'rgba(255, 255, 255, 0.8)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaWhite90: 'rgba(255, 255, 255, 0.9)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  gray: '#E0E0E0',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  grayLight: '#F0F3F7',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  backgroundgray: '#F2F4F7',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaInputRegular: 'rgba(0, 41, 91, 0.06)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utblue: '#004BFF',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utblueHover: '#447BFF',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  utBlueActive: '#003DD0',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  proBlue: '#176CD4',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  blue: '#0B5ACD',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  blueLight50: '#3187EE',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight55: 'rgba(23, 108, 212, 0.1)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight60: 'rgba(23, 108, 212, 0.2)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight65: 'rgba(0, 75, 185, 0.15)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaBlueLight75: 'rgba(23, 108, 212, 0.1)',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  orange: '#FF8800',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaOrangeLight65: 'rgba(217, 116, 0, 0.2)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  orangeLight75: '#FFF3E6',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  brown: '#65290D',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaYellowLight65: 'rgba(101, 41, 13, 0.1)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  yellowLight75: '#FFF8D9',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  green: '#3BA900',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  greenBright10: '#4ECF00',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  rgbaGreenLight65: 'rgba(59, 169, 0, 0.2)',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  greenLight75: '#E2F2D9',

  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  red: '#ED4040',

  /* Цвета для ui-kit компонента Hint */
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintWarning: '#FFDC4C',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintError: '#FF9A26',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintInfo: '#D7E2EF',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintSuccess: '#72C233',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintAlert: '#F1DED8',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintBuy: '#3187EE',
  /**
   * @deprecated Это легаси цвет, не используй его!
   */
  hintSell: '#ED4040'
};
